// Popula a seção
function populateBanners($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    // Efeito da imagem
    const imgZoomClass = section['zoom-enable'] == 1 ? 'img-zoom' : '';

    // Grid e mosaico
    const mosaicLgClass = section['grid-desktop'].includes('mosaic') ? section['grid-desktop'] : '';
    const mosaicMdClass = section['grid-tablet'].includes('mosaic') ? section['grid-tablet'] : '';
    const mosaicSmClass = section['grid-mobile'].includes('mosaic') ? section['grid-mobile'] : '';
    section['grid-desktop'] = section['grid-desktop'].includes('mosaic') ? 'grid-12' : section['grid-desktop'];
    section['grid-tablet'] = section['grid-tablet'].includes('mosaic') ? 'grid-md-12' : section['grid-tablet'];
    section['grid-mobile'] = section['grid-mobile'].includes('mosaic')
      ? 'grid-sm-12 grid-xs-12'
      : section['grid-mobile'];

    // Itens
    let itensHTML = `<div class="row flex-center banners-lista ${mosaicLgClass} ${mosaicMdClass} ${mosaicSmClass}"></div>`;
    let $itens = $(itensHTML);
    if (section['lista'] && section['lista'].length > 0) {
      section['lista'].forEach((item, itemIx) => {
        let bannerItemMosaicClass = '';
        if (mosaicLgClass === 'mosaic-left') {
          bannerItemMosaicClass = itemIx === 0 ? 'mosaic-item-lg' : 'mosaic-item-sm';
        }
        if (mosaicLgClass === 'mosaic-right') {
          bannerItemMosaicClass = itemIx === 2 ? 'mosaic-item-lg' : 'mosaic-item-sm';
        }
        // Imagem
        const imgMobile = item['img_mb'] ? item['img_mb'] : item['img'];
        // Conteúdo
        let itemContent = '';
        if (item['show-content']) {
          itemContent = `
          <div class="banner-content-wrp ${item['alinhamento']} ${
            section['lista-img-format']
          } ${bannerItemMosaicClass}">
            <div class="banner-content">
              ${item['subtitulo'] ? `<div class="banner-subtitle">${item['subtitulo']}</div>` : ''}
              ${item['titulo'] ? `<div class="banner-title">${item['titulo']}</div>` : ''}
              ${item['texto'] ? `<div class="banner-text">${mdParse(item['texto'], true)}</div>` : ''}
              ${
                item['btn-text']
                  ? `<div class="banner-btn"><button class="btn ${item['btn-class']} ${
                      confTheme['general'][item['btn-class'] + '-style']
                    }">${item['btn-text']}</button></div>`
                  : ''
              }
            </div>
          </div>`;
        }
        // Contador
        let itemCountdown = '';
        if (item['countdown-show'] == '1') {
          itemCountdown = `
          <div class="countdown-wrp ${item['countdown-pos']}">
            <div class="countdown countdown-badge" data-mode="minutes" data-minutes="${item['countdown-minutes']}">
              <div class="countdown-icon">${getSvgIcon('clock')}</div>
              <div class="cd-item cd-hours">
                <div class="cd-number" data-cd="hours">00</div>
                <div class="cd-caption">Horas</div>
              </div>
              <div class="cd-separator cd-hours">:</div>
              <div class="cd-item">
                <div class="cd-number" data-cd="minutes">00</div>
                <div class="cd-caption">Minutos</div>
              </div>
              <div class="cd-separator">:</div>
              <div class="cd-item">
                <div class="cd-number" data-cd="seconds">00</div>
                <div class="cd-caption">Segundos</div>
              </div>
            </div>
          </div>`;
        }
        // HTML do item
        let itemHTML = `
        <div class="${section['grid-desktop']} ${section['grid-tablet']} ${section['grid-mobile']} banner-item-wrp">
          <a href="${item['url']}" class="banner-item ${imgZoomClass}">
            <figure class="img ${section['lista-img-format']}">
              <img class="d-none-sm d-none-xs" src="${item['img']}" width="100%" height="300px" alt="${item['alt']}">
              <img class="d-none-xl d-none-lg d-none-md" src="${imgMobile}" width="100%" height="300px" alt="${item['alt']}">
            </figure>
            ${itemContent}
            ${itemCountdown}
          </a>
        </div>`;
        const $item = $(itemHTML);
        // Estilos
        $item[0].style.setProperty('--banner-tit-color', item['banner-tit-color']);
        $item[0].style.setProperty('--banner-overlay-color', item['banner-overlay-color']);
        $item[0].style.setProperty('--banner-sub-color', item['banner-sub-color']);
        $item[0].style.setProperty('--banner-txt-color', item['banner-txt-color']);
        $item[0].style.setProperty('--countdown-bg-color', item['countdown-bg-color']);
        $item[0].style.setProperty('--countdown-txt-color', item['countdown-txt-color']);
        $itens.append($item);
      });
    }

    // Instagram
    let $instagram = '';
    if (section['insta-show'] == '1') {
      $instagram = `<div class="row insta-cta-wrp">
        <a href="${section['insta-url']}" target="_blank" class="insta-cta">
          <div class="insta-cta-icon">${getSvgIcon('instagram')}</div>
          <div class="insta-cta-infos">
            <div class="insta-cta-txt">${section['insta-txt']}</div>
            <div class="insta-cta-link">${section['insta-user']}</div>
          </div>
        </a>
      </div>`;
    }

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="banners" class="home-section banners bg-image ${showSectionClass}">
      <div class="section-content">
        <div class="container">
          ${$instagram}
          ${$itens[0].outerHTML}
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);

    // Plugins
    setTimeout(() => {
      initCountdowns();
    }, 100);
  }
}
